import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconBookBold: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9386 4.1109C20.3196 4.0129 20.7106 4.0979 21.0176 4.3359C21.3246 4.5749 21.4996 4.9349 21.4996 5.3219V17.0079C21.4996 17.5789 21.1146 18.0769 20.5616 18.2189L12.9996 20.1599V5.8939L19.9386 4.1109ZM4.058 4.1106L11 5.8936V20.1606L3.438 18.2186C2.886 18.0776 2.5 17.5796 2.5 17.0076V5.3226C2.5 4.9346 2.676 4.5756 2.982 4.3356C3.288 4.0986 3.681 4.0156 4.058 4.1106Z"
        fill={fill}
      />
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="2"
        y="4"
        width="20"
        height="17"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9386 4.1109C20.3196 4.0129 20.7106 4.0979 21.0176 4.3359C21.3246 4.5749 21.4996 4.9349 21.4996 5.3219V17.0079C21.4996 17.5789 21.1146 18.0769 20.5616 18.2189L12.9996 20.1599V5.8939L19.9386 4.1109ZM4.058 4.1106L11 5.8936V20.1606L3.438 18.2186C2.886 18.0776 2.5 17.5796 2.5 17.0076V5.3226C2.5 4.9346 2.676 4.5756 2.982 4.3356C3.288 4.0986 3.681 4.0156 4.058 4.1106Z"
          fill="white"
        />
      </mask>
    </Icon>
  );
};

export default IconBookBold;
